export const isReserved = status => ['assignment_reservation', 'reservStatus'].includes(status);



// WEBPACK FOOTER //
// ./src/helper.js